module.exports = __webpack_public_path__ + "media/images/emblems/Kiesen-coat_of_arms-54cc5d249ce63c9dfdca8c6ce0bf52ab.svg";